// extracted by mini-css-extract-plugin
module.exports = {"section":"Option_section__2hbB6","active":"Option_active__Ee7xa","soon":"Option_soon__32ZfK","details":"Option_details__1ycHS"};